import { render, staticRenderFns } from "./ReAgreeTermItemForm.vue?vue&type=template&id=c2035444&"
import script from "./ReAgreeTermItemForm.vue?vue&type=script&lang=ts&"
export * from "./ReAgreeTermItemForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports